import { createSelector } from 'reselect';

const selectInfluencers = (state: any) => state.influencers;


export const selectInfluencersCurrentItem = createSelector([selectInfluencers], (influencers) => influencers.current);

export const selectInfluencersListItems = createSelector([selectInfluencers], (influencers) => influencers.list);

export const selectInfluencersItemById = (itemId: any) =>
    createSelector(selectInfluencersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectInfluencersQueryItems = createSelector([selectInfluencers], (influencers) => influencers.query);

export const selectInfluencersCreatedItem = createSelector([selectInfluencers], (influencers) => influencers.create);

export const selectInfluencersUpdatedItem = createSelector([selectInfluencers], (influencers) => influencers.update);

export const selectInfluencersReadItem = createSelector([selectInfluencers], (influencers) => influencers.read);

export const selectInfluencersDeletedItem = createSelector([selectInfluencers], (influencers) => influencers.delete);

export const selectInfluencerssearchedItems = createSelector([selectInfluencers], (influencers) => influencers.search);

export const selectInfluencersItemsCount = createSelector([selectInfluencers], (influencers) => influencers.count);

export const selectInfluencersItemsFilter = createSelector([selectInfluencers], (influencers) => influencers.filter);